(() => {
  'use strict';

  const CONTAINER_SELECTOR = '.product-variant-specifications';

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function parseOptionNames(container) {
    const rawOptionNames = container.dataset.productOptions;
    if (!rawOptionNames) return [];

    try {
      const optionNames = JSON.parse(rawOptionNames);
      return Array.isArray(optionNames) ? optionNames : [];
    } catch (error) {
      console.error('Failed to parse product option names for variant specifications.', error);
      return [];
    }
  }

  function getVariantOptions(variant) {
    if (Array.isArray(variant?.options)) {
      return variant.options;
    }

    return [variant?.option1, variant?.option2, variant?.option3].filter(Boolean);
  }

  function buildSpecificationsMarkup(container, variant) {
    if (!variant) {
      const unavailableMessage = container.dataset.unavailableMessage;
      return unavailableMessage ? `<p>${escapeHtml(unavailableMessage)}</p>` : '';
    }

    const optionNames = parseOptionNames(container);
    const optionValues = getVariantOptions(variant);
    const defaultVariantTitle = (container.dataset.defaultVariantTitle || '').trim();
    const rows = [];

    optionNames.forEach((optionName, index) => {
      const optionValue = optionValues[index];
      if (!optionName || !optionValue) return;

      rows.push(`<p><strong>${escapeHtml(optionName)}:</strong> ${escapeHtml(optionValue)}</p>`);
    });

    const variantTitle = typeof variant.title === 'string' ? variant.title.trim() : '';
    if (!rows.length && variantTitle && variantTitle !== defaultVariantTitle) {
      rows.push(`<p><strong>Variant:</strong> ${escapeHtml(variantTitle)}</p>`);
    }

    const variantSku = typeof variant.sku === 'string' ? variant.sku.trim() : '';
    if (variantSku) {
      rows.push(`<p><strong>SKU:</strong> ${escapeHtml(variantSku)}</p>`);
    }

    return rows.join('');
  }

  function updateContainer(container, variant) {
    if (container.dataset.staticOptions === 'true') return;

    const content = container.querySelector('.product-variant-specifications__content');
    const fallback = container.querySelector('[data-variant-specifications-fallback]');

    if (!content) return;

    const markup = buildSpecificationsMarkup(container, variant);

    if (markup) {
      content.innerHTML = markup;
      content.hidden = false;
      if (fallback) fallback.hidden = true;
      return;
    }

    content.innerHTML = '';
    content.hidden = true;

    if (fallback) {
      fallback.hidden = false;
    }
  }

  function handleVariantUpdate(event) {
    const productId = String(event.detail?.data?.productId || event.detail?.data?.newProduct?.id || '');
    const variant = event.detail?.resource || null;

    if (!productId) return;

    document.querySelectorAll(CONTAINER_SELECTOR).forEach((container) => {
      if (container.dataset.productId !== productId) return;
      updateContainer(container, variant);
    });
  }

  document.addEventListener('variant:update', handleVariantUpdate);
})();
